import { FormElementMeta, FormSectionMeta } from '@people-science/forms-core';
import { StateNodeConfig } from '@people-science/state-machine';
import React from 'react';
import { Text } from 'react-native';
import styled from 'styled-components/native';
import { useDynamicFormContext } from './DynamicFormContext';

const StyledFormElementView = styled.View`
  margin-bottom: 48px;
`;

export type FormElementProps<FormValuesType, FormElementConfigType> = {
  stateNode: StateNodeConfig<
    FormSectionMeta<FormValuesType, FormElementConfigType>
  >;
  element: FormElementMeta<FormValuesType, FormElementConfigType>;
  value?: Partial<FormValuesType>;
  disabled?: boolean;
  edit?: boolean;
};

export type FormElementSelectProps = {};

export const FormElement = <
  FormValuesType extends object,
  FormElementConfigType extends object
>({
  stateNode,
  element,
  edit,
  disabled,
  ...props
}: React.PropsWithChildren<
  FormElementProps<FormValuesType, FormElementConfigType> &
    FormElementSelectProps
>) => {
  const { formState, elementPlugins } = useDynamicFormContext<
    FormValuesType,
    FormElementConfigType
  >();
  const plugin = elementPlugins.find(p => p.type === element.type);
  if (plugin?.element) {
    return (
      <StyledFormElementView>
        <plugin.element
          stateNode={stateNode}
          element={element}
          edit={edit}
          disabled={disabled}
        />
      </StyledFormElementView>
    );
  }
  return <Text>Form element &quot;{element.type}&quot; not found.</Text>;
};

export default FormElement;
